import { Component, Input } from '@angular/core';
import { EstatusJSON } from '../../../shared/models/EstatusJSON';
import { AlarmDTO } from '../../models/AlarmDTO';
import { ActiveAlarmsPopupComponent } from '../active-alarms-popup/active-alarms-popup.component';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { GeofencesService } from 'src/app/features/geofences-map/services/Geofences.service';
import { ConfirmDialogService } from 'src/app/features/shared/features/confirm-dialog/services/Confirm-Dialog.service';
import { MessageDialogService } from 'src/app/features/shared/features/message-dialog/services/message-dialog.service';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { AlarmService } from '../../service/Alarm.service';

@Component({
  selector: 'alarm-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.css']
})
export class ActionsComponent {

  @Input() alarmData: AlarmDTO;
  @Input() canBeLocked: boolean = false;
  @Input() isLocked: boolean = false;

  isLoading: boolean = false;

  suscription_getGeofence: Subscription;
  suscription_delete: Subscription;
  suscription_confirmDialogService: Subscription;
  suscription_createBlokingRequest: Subscription;
  suscription_deactivateAlarm: Subscription;

  constructor(
    private alarmService: AlarmService,
    private notifyService: SwalNotificationService,
    private geofenceService: GeofencesService,
    private confirmDialogService: ConfirmDialogService,
    private citronellaActionsService: CitronellaActionsService,
    private messageDialogService: MessageDialogService,
    public dialogRef: MatDialogRef<ActiveAlarmsPopupComponent>,
  ) { }

  ngOnDestroy(): void {
    if(this.suscription_delete)
      this.suscription_delete.unsubscribe();
    if(this.suscription_getGeofence)
      this.suscription_getGeofence.unsubscribe();
    if(this.suscription_confirmDialogService)
      this.suscription_confirmDialogService.unsubscribe();
    if(this.suscription_createBlokingRequest)
      this.suscription_createBlokingRequest.unsubscribe();
    if(this.suscription_deactivateAlarm)
      this.suscription_deactivateAlarm.unsubscribe();
  }


  DeactivateAlarm(){
    console.log("Desactivar alarma", this.alarmData);
    this.isLoading = true;
    this.notifyService.confirmMessage("Desactivar", "¿Deseas desactivar la alarma?").then((result) => {
      if (result.value) {
        this.suscription_deactivateAlarm = this.alarmService.DeactivateAlarms(this.alarmData.id).subscribe((alarmData) => {
          if(alarmData.isSuccess){
            this.notifyService.MessageSuccessful("Alarma desactivada correctamente", "exito");
            this.isLoading = false;
            this.dialogRef.close(true);
          }
          this.isLoading = false;
        });
      }else{
        this.isLoading = false;
      }
    });
  }

  DeactivateGeofence(){
    this.isLoading = true;
    this.suscription_getGeofence = this.geofenceService.get(this.alarmData.idGeofence).subscribe((alarmData) => {
      if(alarmData.isSuccess){
        var identifiers = alarmData.result.identifiers.join(',');
        var resp = this.notifyService.confirmMessage("Desactivar","¿Seguro que desea desactivar esta geocerca?, tiene los siguienetes activos asignados: "+ identifiers);
        resp.then((result) =>{
           if(result.value)
           {
              this.suscription_delete = this.geofenceService.Deactivate(this.alarmData.idGeofence).subscribe((alarmData)=>{
                if(alarmData.isSuccess == true){
                  this.notifyService.MessageSuccessful("Desactivado","Geocerca desactivada exitosamente");
                  this.DeactivateAlarm();
                }else{
                  this.notifyService.MessageError("Problema al desactivar la geocerca");
                }

                this.isLoading = false;
              });
            }else{
              this.isLoading = false;
            }
         }); 
      }else{
        this.isLoading = false;
      }
    });
  }

  UnassignFromGeofence(){
    this.isLoading = true;
    var resp = this.notifyService.confirmMessage("Desasignar","¿Seguro que desea desasignar el auto"+ this.alarmData.identifier +"de la geocerca?");
    resp.then((result) =>{
      if(result.value)
      {
         this.suscription_delete = this.geofenceService.UnassignIdentifier(this.alarmData.idGeofence, this.alarmData.identifier).subscribe((alarmData)=>{
           if(alarmData.isSuccess == true){
             this.notifyService.MessageSuccessful("Desasignado","Activo desasignada exitosamente");
             this.DeactivateAlarm();
           }else{
             this.notifyService.MessageError("Problema al desasignar de la geocerca");
           }
           this.isLoading = false;
         });

       }else{
        this.isLoading = false;
       }
    }); 
  }

  DeleteValetParking(){
    this.isLoading = true;
    this.notifyService.confirmMessage("Apagar", "Seguro que quieres desactivar el valet parking?").then((result) => {
      if (result.value) {
        this.suscription_delete = this.geofenceService.FullDelete(this.alarmData.idGeofence).subscribe((alarmData)=>{
          if(alarmData.isSuccess == true){
            this.notifyService.MessageSuccessful("Apagado","Valet Parking se ha desactivado exitosamente");
            this.DeactivateAlarm();
          }else{
            this.notifyService.MessageError("Problema al desactivar el Valet Parking");
          }
          this.isLoading = false;
        });
      }else{
        this.isLoading = false;
      }
    });
  }

  BlockActive() {
    this.isLoading = true;
    const title = `Solicitud de bloqueo`;
    const message = `¿Desea realizar una solicitud de bloqueo para el activo '${this.alarmData.identifier}'?`;
    
    if (!this.canBeLocked) {
      this.messageDialogService.show(title, "El activo no puede ser bloqueado o desbloqueado");
      this.isLoading = false;
      return;
    }

    if (this.isLocked) {
      this.messageDialogService.show(title, "El activo ya se encuentra bloqueado");
      this.isLoading = false;
      return;
    }

    this.suscription_confirmDialogService = this.confirmDialogService
      .show(title, message)
      .subscribe((result) => {
        if (result) {
          this.suscription_createBlokingRequest = this.citronellaActionsService
            .createBlokingRequest(this.alarmData.identifier)
            .subscribe((alarmData: EstatusJSON) => {
              this.messageDialogService.show(title, alarmData.message);
            });
            this.isLoading = false;
        }else{
          this.isLoading = false;
        }

      });
  }

  UnblockActive() {
    this.isLoading = true;
    const title = `Solicitud de bloqueo`;
    const message = `¿Desea realizar una solicitud de bloqueo para el activo '${this.alarmData.identifier}'?`;
    
    if (!this.canBeLocked) {
      this.messageDialogService.show(title, "El activo no puede ser bloqueado o desbloqueado");
      this.isLoading = false;
      return;
    }

    if (!this.isLocked) {
      this.messageDialogService.show(title, "El activo no se encuentra bloqueado");
      this.isLoading = false;
      return;
    }

    this.suscription_confirmDialogService = this.confirmDialogService
      .show(title, message)
      .subscribe((result) => {
        if (result) {
          this.suscription_createBlokingRequest = this.citronellaActionsService
            .createBlokingRequest(this.alarmData.identifier)
            .subscribe((alarmData: EstatusJSON) => {
              this.messageDialogService.show(title, alarmData.message);
              this.isLoading = false;
            });
        }else{
          this.isLoading = false;
        }
      });
  }

}
